import { render, staticRenderFns } from "./getElectricshock.vue?vue&type=template&id=c7b97f4a&scoped=true&"
import script from "./getElectricshock.vue?vue&type=script&lang=js&"
export * from "./getElectricshock.vue?vue&type=script&lang=js&"
import style0 from "./getElectricshock.vue?vue&type=style&index=0&id=c7b97f4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b97f4a",
  null
  
)

export default component.exports